import React from 'react'
import useSingleStation from '../../../hooks/useSingleStation'
import { limitString } from '../../../../../utils/string.utils'

export default function SingleStationName({idStation, limit}:{idStation?: string, limit?: number}) {
   const {singleStationQuery : {isLoading, isError, data}} = useSingleStation(idStation)

   isLoading && <>...</>
    isError && <>Error</>

    if (!data) return <></>
  return (
    <>
     {limitString(data?.station_name, limit)}
    </>
  )
}
